/**
 * Messages Page
 *
 * Customer communications and internal messaging.
 * PURELY PRESENTATIONAL - placeholder for Phase 3 implementation.
 */

import { PageHeader } from '@/components/service-provider/PageHeader';

export function MessagesPage() {
  return (
    <div>
      <PageHeader
        title="Messages"
        description="Customer inquiries and internal communications"
        breadcrumbs={[
          { label: 'Dashboard', href: '/provider/dashboard' },
          { label: 'Messages' },
        ]}
      />

      <div className="card">
        <div className="card-content text-center py-12">
          <svg
            className="w-16 h-16 text-neutral-400 mx-auto mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
            />
          </svg>
          <h3 className="text-lg font-semibold text-neutral-900 mb-2">
            Messages - Coming Soon
          </h3>
          <p className="text-neutral-600 mb-4">
            Thread view by job, customer profiles, and message templates.
          </p>
          <p className="text-sm text-neutral-500">
            Phase 3 - Business Features Implementation
          </p>
        </div>
      </div>
    </div>
  );
}
